<template>
	<div class="red-package-sender-comp">
		<div class="red-package-sender-comp-wrap">
			<fieldset>
				<legend>
					<span>红包参数</span>
					<span class="red-package-sender-comp-change" @click="changeType">切</span>
				</legend>
				<div class="red-package-sender-comp-items" v-if="sType === 1">
					<div class="red-package-sender-comp-item">
						<label for="">红包金额：</label>
						<input type="number" v-model="repuestParam.money">
						<span>分</span>
					</div>
					<div class="red-package-sender-comp-item">
						<label for="">过期时间：</label>
						<input type="number" v-model="repuestParam.red_expire_in">
						<span>秒</span>
					</div>
					<div class="red-package-sender-comp-item">
						<label for="">转账备注：</label>
						<input type="text" v-model="repuestParam.transfer_remark">
					</div>
					<div class="red-package-sender-comp-item">
						<button @click="sendRedPacket">红包发送</button>
					</div>
				</div>
				<div class="red-package-sender-comp-items" v-else>
					<div class="red-package-sender-comp-item-wrap" v-for="(history,key) in historyList">
						<div class="red-package-sender-comp-item">
							<label for="">红包金额：</label>
							<p><span style="font-weight: bold;">{{history.money / 100}}</span>元</p>
							<button style="margin-left: 20px;font-size: 12px;background-color: black;" @click="delRedPacket(history.rpu_id)">作废</button>
						</div>
						<div class="red-package-sender-comp-item">
							<label for="">转账备注：</label>
							<p>{{history.transfer_remark}}</p>
						</div>
						<div class="red-package-sender-comp-item">
							<label for="">领取状态：</label>
							<p v-if="history.receive_status == 1">待领取</p>
							<p v-else-if="history.receive_status == 2" style="color: orange;">领取中</p>
							<p v-else-if="history.receive_status == 3" style="color: green;">领取完成</p>
							<p v-else-if="history.receive_status == 4" style="color: red">领取失败</p>
							<p v-else-if="history.receive_status == 5" style="color: #999999;">已失效</p>
							<p v-else-if="history.receive_status == 6" style="color: #999999;">已作废</p>
						</div>
						<div class="red-package-sender-comp-item">
							<label for="">生成时间：</label>
							<p>{{history.create_time}}</p>
						</div>
					</div>
					
				</div>
			</fieldset>
		</div>	
	</div>
</template>

<script>
	import {webSaveRedPacket,webGetRedPacketList,webDelRedPacket} from '../network/web/other.js'
	
	export default{
		name:'RedPacket',
		components:{
			
		},
		props:{
			chatId:{
				default:0
			},
		},
		data(){
			return{
				sType: 1,
				historyList:[],
				repuestParam:{
					money: 100,
					red_expire_in: 7200,
					transfer_remark: '恭喜发财，大吉大利'
				}
			}
		},
		methods:{
			//关闭页面
			close(){
				this.$emit("close-circle-remind")
			},
			
			// 切换显示类型
			changeType(){
				this.sType = this.sType === 1 ? 2 : 1;
			},
			
			// 红包发送
			sendRedPacket(){
				let _this = this
				CHAT_LAYER.confirm('确定要执行吗？红包金额：'+(this.repuestParam.money / 100) + '元', {
					title: '红包确认',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					let param = {
						money: _this.repuestParam.money,
						red_expire_in:  _this.repuestParam.red_expire_in,
						transfer_remark: _this.repuestParam.transfer_remark,
						fans_id: _this.chatId
					}
					webSaveRedPacket(param,data=>{
						if(data.code == 0){
							CHAT_LAYER.msg(data.msg,{icon: 2})
						}else{
							CHAT_LAYER.msg('操作成功',{icon: 1})
							_this.$emit("close-circle-remind")
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			},
			
			// 红包作废
			delRedPacket(id){
				let _this = this
				CHAT_LAYER.confirm('确定作废当前红包吗？', {
					title: '作废确认',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					webDelRedPacket(id,data=>{
						if(data.code == 0){
							CHAT_LAYER.msg(data.msg,{icon: 2})
						}else{
							CHAT_LAYER.msg('操作成功',{icon: 1})
							_this.$emit("close-circle-remind")
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			}
			
		},
		created() {
			let _this = this
			_this.historyList = []
			_this.sType = 1
			webGetRedPacketList(this.chatId,data=>{
				if(data.code == 1){
					_this.historyList = data.data
				}
			})
		}
	}
</script>

<style>
	.red-package-sender-comp{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
		max-width: 1300px;
		margin: 0 auto;
	}
	.red-package-sender-comp-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: flex-start;
		padding: 10px;
		box-sizing: border-box;
	}
	.red-package-sender-comp-wrap legend{
		padding: 0 20px;
		font-size: 16px;
	}
	.red-package-sender-comp-wrap legend span{
		display: inline-block;
		user-select: none;
	}
	.red-package-sender-comp-items{
		max-height: 350px;
		overflow: auto;
	}
	.red-package-sender-comp-item-wrap{
		border-bottom: 1px solid #ccc;
	}
	.red-package-sender-comp-item-wrap:last-child{
		border-bottom: unset;
	}
	.red-package-sender-comp-item{
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.red-package-sender-comp-item input{
		border-bottom: 1px solid #ccc;
		width: 200px;
	}
	.red-package-sender-comp-wrap button{
		padding: 2px 5px;
		border-radius: 2px;
		background-color: #009688;
		color: #FFFFFF;
		cursor: pointer;
	}
	.red-package-sender-comp-change{
		margin-left: 10px;
		font-size: 14px;
		background-color: chocolate;
		color: #ffffff;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		cursor: pointer;
	}
</style>
